import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const BIGFOOTERCOLUMNBLOCK_LEGACY_FIELD_ORDER = [
  "title"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  bigFooterColumnBlockDescriptor: _generatedBigFooterColumnBlockDescriptor,
  bigFooterColumnBlockBlocDefinition,
  bigFooterColumnBlockDashboardLayout,
  bigFooterColumnBlockConfig,
  bigFooterColumnBlockResolveConfig,
  bigFooterColumnBlockProperties,
} = doodBlockConfig(
  {
    name: "Big footer - Column",
    componentType: 'BigFooterColumnBlockComponent',
    category: 'footer',
    description: "Big footer - Column.",
    keywords: [],
    allowedIn: [
      { bloc: "BigFooterBlockComponent", slot: "columns" },
      { bloc: "BigFooterBlockComponent", slot: "left_body" },
    ],
    sharedFields: {},
    slots: [
      {
        key: 'items',
        name: 'pages.blocks.big-footer-column.items.label',
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterColumnItemBlock", "BigFooterBodyCallToActionBlock", "BigFooterBodyLogoBlock", "BigFooterBodySocialNetworksBlock", "BigFooterBodyDownloadAppsBlock", "CookieConsentLinkItemBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.big-footer-column.title.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.big-footer-column.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.big-footer-column.fieldset.title.label",
            fields: ["title"],
          },
          {
            legend: "pages.blocks.big-footer-column.fieldset.items.label",
            fields: ["items"],
          },
        ],
      },
    ],
  })
);

export function bigFooterColumnBlockDescriptor(): IBlockDescriptor;
export function bigFooterColumnBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function bigFooterColumnBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedBigFooterColumnBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedBigFooterColumnBlockDescriptor, bigFooterColumnBlockProperties, fieldOrder);
}

export {
  bigFooterColumnBlockBlocDefinition,
  bigFooterColumnBlockDashboardLayout,
  bigFooterColumnBlockProperties,
  bigFooterColumnBlockConfig,
  bigFooterColumnBlockResolveConfig,
};

export type BigFooterColumnBlockConfig = typeof bigFooterColumnBlockConfig;
